import { Typography } from '@material-ui/core'

import { SessionState } from '../../types/iamSessions'
import { useStyles } from './styles/index.styles'

type StatusBoxProps = { state: SessionState }
export default function SessionStateBox({ state }: StatusBoxProps) {
  const classes = useStyles()
  return (
    <div
      className={[
        classes.statusContainer,
        state === 'Active' && classes.greenStatus,
        state === 'Expired' && classes.greyStatus,
        state === 'Revoked' && classes.redStatus
      ].join(' ')}>
      <Typography className={classes.statusText}>{state}</Typography>
    </div>
  )
}
